import { I18nComponente } from "@/types/gerais"

export const ODadosProjetoi18n: I18nComponente = {
  "pt-BR": {
    nomeDoProjeto: "nome do projeto",
    codigo: "código",
    usuariosResponsaveis: "usuários responsáveis",
    campoObrigatorio: "campo obrigatório",
    nomeDoProjetoNaoPodeUltrapassar256Caracteres: "O nome do projeto não pode ultrapassar 256 caracteres",
  },
  "es-CO": {
    nomeDoProjeto: "nombre del proyecto",
    codigo: "código",
    usuariosResponsaveis: "usuarios responsables",
    campoObrigatorio: "campo obligatorio",
    nomeDoProjetoNaoPodeUltrapassar256Caracteres: "El nombre del proyecto no puede superar los 256 caracteres",
  }
}
